const loadImages = () => {
    let allImages = document.querySelectorAll('img[loading="lazy"]') as NodeListOf<HTMLImageElement>

    if (document.querySelector('.body-iframe') && document.querySelector('#focus-element') && allImages.length > 0) {
        allImages.forEach(image => {
            image.loading = 'eager'
        })
        let focusElement = document.querySelector('#focus-element')
        focusElement.scrollIntoView()
    }

    setTimeout(() => {
        window.print()
    }, 500)
}

export function initPrintFunctions() {
    if (document.querySelector('.button--print')) {
        document.querySelector('.button--print').addEventListener('click', loadImages)
    }
}